/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';

@Component({
  standalone: false,
  selector: 'gh-system-vars-tab-container',
  templateUrl: 'system-vars-tab-container.component.html',
})
export class SystemVarsTabContainerComponent {
  constructor(public userContext: BuilderUserContext) {
  }
}
